import { memo, useMemo } from 'react';
import { Flex, IconButton, Text } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { IndicatorDriver } from 'models/response/driver.interface';
import { getBlockDriversData } from 'redux/PlanPageSlice';
import { getPlanPageThemeColors } from 'redux/ThemeSlice';

import EditDriversSection from '../../Plan/EditDriverSection';
import { WhatIfsPanelChevronIcon } from '../icons/DriverPanelFigmaIcons';
import { PLAN_TEXT, PLAN_WHATIFS_PANEL_WIDTH } from '../planPageRevampUi';

interface Properties {
  onToggleAuthModal: () => void;
  onClose: () => void;
}

const PlanWhatIfsPanel = ({ onToggleAuthModal, onClose }: Properties) => {
  const themeColors = useSelector(getPlanPageThemeColors);
  const blockDrivers = useSelector(getBlockDriversData);

  const indicatorDrivers = useMemo(
    () =>
      (blockDrivers ?? []).filter(
        (driver: IndicatorDriver) => driver.type === 'indicator',
      ) as IndicatorDriver[],
    [blockDrivers],
  );

  if (indicatorDrivers.length === 0) {
    return null;
  }

  return (
    <Flex
      direction='column'
      h='100%'
      minH={0}
      w={PLAN_WHATIFS_PANEL_WIDTH}
      minW={PLAN_WHATIFS_PANEL_WIDTH}
      flexShrink={0}
      bg={themeColors.surface}
      borderLeft='1px solid'
      borderColor={themeColors.border}
      overflow='hidden'
    >
      <Flex alignItems='center' gap={3} px={5} pt={5} pb={4} flexShrink={0}>
        <IconButton
          aria-label='Close what ifs panel'
          icon={<WhatIfsPanelChevronIcon color={themeColors.textDark} />}
          variant='ghost'
          size='sm'
          minW='20px'
          w='20px'
          h='20px'
          p={0}
          color={themeColors.textDark}
          _hover={{ bg: 'transparent', color: themeColors.primary }}
          onClick={onClose}
        />
        <Text {...PLAN_TEXT.inputsPanelTitle} color={themeColors.textDark}>
          What Ifs
        </Text>
      </Flex>

      <Flex flex='1' minH={0} direction='column' overflowY='auto' className='scroll'>
        <EditDriversSection
          variant='revamp'
          hideHeader
          embeddedInWhatIfsPanel
          drivers={indicatorDrivers}
          onToggleAuthModal={onToggleAuthModal}
        />
      </Flex>
    </Flex>
  );
};

export default memo(PlanWhatIfsPanel);
